import React from 'react';
import { EnvironmentOutlined, WhatsAppOutlined, ClockCircleOutlined, MailOutlined } from '@ant-design/icons';
import logo from '../../images/Layout/logo3.svg';
import Contact from '../../../Services/contact';
import styles from './Footer.module.scss';

const Footer: React.FC = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.footer__top}>
        <div className={styles.footer__brand}>
          <img src={logo} alt="Glow Skin logo" className={styles.footer__logo} />
          <h3 className={styles.footer__brandName}>Glow Skin</h3>
        </div>

        <div className={styles.footer__info}>
          <span><EnvironmentOutlined /> Quito Sur, Ecuador</span>
          <span><WhatsAppOutlined /> {Contact.WHATSAPP_DISPLAY}</span>
          <span><ClockCircleOutlined /> Lunes a Viernes 9:00 - 18:00</span>
          <span><MailOutlined /> samirachisaguano@gmail.com</span>
        </div>
      </div>

      <div className={styles.footer__bottom}>
        <p>© {new Date().getFullYear()} Glow Skin. Todos los derechos reservados.</p>
      </div>
    </footer>
  );
};

export default Footer;
